import { render, staticRenderFns } from "./mapUserPopover.vue?vue&type=template&id=04566ff0&"
import script from "./mapUserPopover.vue?vue&type=script&lang=js&"
export * from "./mapUserPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports